import { createSlice } from '@reduxjs/toolkit'

const selectedCenterSlice = createSlice({
  name: 'selectedCenter',
  initialState: { data: null, loading: false },
  reducers: {
    setSelectedCenter(state, action) {
      return { data: action.payload, loading: false }
    },
    updateSelectedCenter(state, action) {
      return { data: action.payload, loading: false }
    },
    setCenterLoading(state) {
      state.loading = true;
    },
  },
})

export const { setSelectedCenter, setCenterLoading, updateSelectedCenter } =
  selectedCenterSlice.actions

export const selectCenter = (selectedCenterObj) => {
  return (dispatch) => {
    dispatch(setCenterLoading())
    setTimeout(() => {
      dispatch(setSelectedCenter(selectedCenterObj))
    }, 500)
  }
}

export default selectedCenterSlice.reducer